export default "__VITE_ASSET__BC5A6CM5__"